<!-- init -->
<template>
  <div class="event-knowledge_base">
    <modal :title="title" :subtitle="''"
      v-on:close="switchModal()"
      v-if="modal">
      <event-file v-on:close="switchModal" :data="editableFile"/>
    </modal>
    <div class="knowledge_base-actions">
      <ccs-input class="action-search" type="text" label=""
        v-model.trim="fileSearch" placeholder="Поиск по названию"/>
      <button class="ccs-button ccs-button--white ccs-button--small" @click="switchModal()">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Добавить файл
      </button>
    </div>
    <ccs-table :data="filteredFiles" :columnsDefs="columnsDefs">
      <template v-slot:url="props">
        <v-icon class="ccs-icon--primary ccs-icon--hover" name="download" scale="0.9"
          @click="downloadFile(props.row.url)"/>
        <v-icon class="ccs-icon--primary ccs-icon--hover" name="file" scale="0.9"
          @click="openFileLink(props.row.url)"/>
        <v-icon class="ccs-icon--primary ccs-icon--hover" name="edit"
          @click="switchModal(props.row)"/>
        <v-icon class="ccs-icon--secondary ccs-icon--hover" name="trash" scale="0.9"
          @click="removeFile(props.row)"/>
      </template>
    </ccs-table>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import Modal from '@/components/Modal.vue';
import Table from '@/components/Table.vue';
import Input from '@/components/forms/Input.vue';
import EventFile from '@/components/modals/events/EventFile.vue';

export default {
  name: 'KnowledgeBase',
  components: {
    'ccs-input': Input,
    'ccs-table': Table,
    Modal,
    EventFile,
  },
  data() {
    return {
      modal: false,
      titles: {
        new: 'Новый файл',
        edit: 'Редактирование файла',
      },
      columnsDefs: [{
        name: `name`,
        title: 'Название',
        prop: 'name',
        emptyText: 'Не назначено'
      }, {
        name: `version`,
        title: `Версия`,
        prop: 'version',
        emptyText: 'Не назначена'
      }, {
        name: `url`,
        title: ``,
        prop: `url`,
        isActions: true
      }],
      editableFile: null,
      fileSearch: '',
    };
  },
  computed: {
    ...mapState('events', ['event', 'eventFiles']),
    title() {
      return Object.keys(this.editableFile).length !== 0 ? this.titles.edit : this.titles.new;
    },
    filteredFiles() {
      return this.eventFiles.filter(item => !item.name || item.name.indexOf(this.fileSearch) !== -1);
    },
  },
  methods: {
    ...mapActions('session', ['deleteFile']),
    ...mapActions('events', ['getEvent']),
    switchModal(editableFile = null) {
      this.modal = !this.modal;
      this.editableFile = Object.assign({}, editableFile);
    },
    downloadFile(url) {
      window.open(url.replace("/storage/app/public/", "/storage/app/download/"), '_blank');
    },
    openFileLink(url) {
      window.open(url, '_blank');
    },
    async removeFileRequest(fileInfo) {
      try {
        await this.deleteFile(fileInfo.id);
        this.getEvent();
        this.$toasted.success('Файл удалён');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    removeFile(fileInfo) {
      this.$toasted.info("Удалить файл?", { action: [{
        text: "Да",
        onClick: (e, toastObject) => {
          this.removeFileRequest(fileInfo);
          toastObject.goAway(0);
        },
      }, {
        text: "Нет",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      }]});
    },
  },
};
</script>

<style lang="scss" scoped>
.event-knowledge_base {
  min-height: 100%;
  min-width: 100%;

  .knowledge_base-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ccs-table {
    margin-top: 20px;
  }

  .button--add {
    margin-top: 22px;
  }

  .modal-table {
    margin-top: 30px;
  }

}
</style>
